import Vue from 'vue'
import VueRouter from 'vue-router'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import GlobalMixins from './globalMixins'
import App from './App'

// router setup
import routes from './routes/routes'

// library imports
import Chartist from 'chartist'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/sass/material-dashboard.scss'
import 'es6-promise/auto'
import VueResource from 'vue-resource'
// Spanish Dic for errors
import VeeValidate, {Validator} from 'vee-validate'
import es from 'vee-validate/dist/locale/es.js'
// import * as VueGoogleMaps from 'vue2-google-maps'
import VueGoodTable from 'vue-good-table'
import VueClipboard from 'vue-clipboard2'

// this is to be able to use new component from github:xaksis/vue-good-table
// import the styles 
import 'vue-good-table/dist/vue-good-table.css'

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalComponents)
Vue.use(GlobalDirectives)
Vue.use(GlobalMixins)
Vue.use(VueResource)
// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize('es', es)
Vue.use(VeeValidate, {locale: 'es'})
// Validator.setLocale('es')
Vue.use(VueGoodTable)
Vue.use(VueClipboard)
// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  data: {
    Chartist: Chartist
  }
})



// WEBPACK FOOTER //
// ./src/main.js